import { Injectable, inject } from '@angular/core';
import { StoreAuthService } from '@app/core/auth/store-auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserRecordListStateService {
  private filterTexts = new Map<string, string>();
  private protocolFilters = new Map<string, string[]>();
  private readonly storeAuth = inject(StoreAuthService);
  private readonly columnVisibilityStorageKeyPrefix = 'gokuri.userRecordList.columnVisibility';

  setFilterText(key: string, value: string): void {
    this.filterTexts.set(key, value);
  }

  getFilterText(key: string): string {
    return this.filterTexts.get(key) ?? '';
  }

  setProtocolFilters(key: string, values: string[]): void {
    this.protocolFilters.set(key, [...values]);
  }

  getProtocolFilters(key: string): string[] | null {
    const values = this.protocolFilters.get(key);
    return values ? [...values] : null;
  }

  setColumnVisibilityMap(visibilityMap: Record<string, boolean>): void {
    const key = this.getColumnVisibilityStorageKey();
    if (!key || typeof localStorage === 'undefined') {
      return;
    }
    try {
      localStorage.setItem(key, JSON.stringify(visibilityMap));
    } catch {
      // localStorage can fail in private mode or when quota is exceeded.
    }
  }

  getColumnVisibilityMap(): Record<string, boolean> | null {
    const key = this.getColumnVisibilityStorageKey();
    if (!key || typeof localStorage === 'undefined') {
      return null;
    }
    try {
      const raw = localStorage.getItem(key);
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') {
        return null;
      }
      return Object.entries(parsed).reduce<Record<string, boolean>>((acc, [k, v]) => {
        if (typeof v === 'boolean') {
          acc[k] = v;
        }
        return acc;
      }, {});
    } catch {
      return null;
    }
  }

  private getColumnVisibilityStorageKey(): string {
    const loginUserName = this.storeAuth.getLoginUserName()?.trim();
    const suffix = loginUserName && loginUserName.length > 0
      ? loginUserName
      : 'anonymous';
    return `${this.columnVisibilityStorageKeyPrefix}.${suffix}`;
  }
}
